import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootReducerType } from "ducks/rootReducer";
import { fetchHomePageData } from "ducks/homePage/actionCreators";

const useHomePageData = () => {
  const dispatch = useDispatch();
  const {
    data: {
      carouselData,
      financialData,
      waysWeCanHelpData,
      productBanner,
      quickLinks,
      latest_news,
      advisories,
    },
    loading,
    error,
  } = useSelector((state: RootReducerType) => state.homePageReducer);

  const dispatchFetchHomePageData = (): void => {
    if (
      carouselData.length <= 0 &&
      financialData.length <= 0 &&
      waysWeCanHelpData.length <= 0 &&
      productBanner.length <= 0
    ) {
      dispatch(fetchHomePageData());
      return;
    }
  };

  useEffect(dispatchFetchHomePageData, []);

  return {
    loading,
    carouselData,
    financialData,
    waysWeCanHelpData,
    productBanner,
    quickLinks,
    latest_news,
    error,
    advisories,
  };
};
export default useHomePageData;
